import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LoginRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const currentUrl = state.url;
    if (currentUrl === '/login') {
      const redirectMap: { [key: string]: string } = {
        cdt: 'https://cdt-wms.fulfillment.maersk.com/',
        americas: 'https://americas-wms.fulfillment.maersk.com/',
      };
      for (const key in redirectMap) {
        if (this.getOrigin().includes(key)) {
          this.redirect(redirectMap[key]);
          return false;
        }
      }
    }

    return true;
  }

  getOrigin(): string {
    return window.origin;
  }

  redirect(url: string): void {
    window.location.href = url;
  }
}
